import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment  } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  mainURL = 'auth/';
  constructor(private http: HttpClient) { }

  loginWithGoogle(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'loginWithGoogle', user);
  }

  loginAsLinkedIn(authCode: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'loginWithLinkedIn', authCode);
  }

  loginAsUser(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'loginAsUser', user);
  }

  registerUser(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'createUser', user);
  }
  
  refreshAccessToken(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'refresh-token', user);
  }

  logoutFromGoogle(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'logoutuser', user);
  }

  resetPassword(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'reset-password', user);
  }

  forgotPassword(email: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'forgot-password', { email });
  }

  verifyOtp(email: any, otp: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'verify-otp', { email, otp });
  }
}
